import type { FunnelData } from '../types'

interface ConversionFunnelProps {
  funnel: FunnelData
}

const STAGE_COLORS = [
  { bg: 'bg-blue-500', light: 'bg-blue-100', text: 'text-blue-700' },
  { bg: 'bg-purple-500', light: 'bg-purple-100', text: 'text-purple-700' },
  { bg: 'bg-indigo-500', light: 'bg-indigo-100', text: 'text-indigo-700' },
  { bg: 'bg-green-500', light: 'bg-green-100', text: 'text-green-700' },
]

export function ConversionFunnel({ funnel }: ConversionFunnelProps) {
  const maxCount = Math.max(...funnel.stages.map((s) => s.count), 1)

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">Conversion Funnel</h3>
      <div className="space-y-3">
        {funnel.stages.map((stage, i) => {
          const widthPct = Math.max((stage.count / maxCount) * 100, 8)
          const colors = STAGE_COLORS[i] || STAGE_COLORS[0]
          return (
            <div key={stage.name}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-gray-700">{stage.name}</span>
                <span className="text-sm text-gray-500">
                  {stage.count} <span className="text-xs">({stage.rate}%)</span>
                </span>
              </div>
              <div className={`h-8 rounded-lg ${colors.light} overflow-hidden`}>
                <div
                  className={`h-full rounded-lg ${colors.bg} transition-all duration-500 flex items-center justify-end pr-2`}
                  style={{ width: `${widthPct}%` }}
                >
                  {widthPct > 20 && (
                    <span className="text-xs font-bold text-white">{stage.count}</span>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
